import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_EDUCATION_LIST_KEY,
  BACKEND_EDUCATION_GOAL_API,
  OTHER_TUITION,
} from '../ChildrenInfoWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import { schoolSelected } from '../ChildrenInfoWorkflowValidator';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

const ChildrenSelectionView = ({
  branch,
  clientId,
  selectedChildFirstName,
  educationTypeOptions,
  store,
  workflowId,
  isEditingGoal,
  educationGoal,
  nextIterators,
  onPostProcess,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    id="ChildrenEducation"
    canSkip={educationGoal.IsSpecificCollege}
  >
    <Validation
      workflowId={workflowId}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.EducationType`}
    />
    <h2>What type of school will {selectedChildFirstName} attend?</h2>
    <AdvForm>
      <ul className="horizontal school-list">
        {educationTypeOptions.map(({ value, label }) => (
          <li key={value} className="school-item">
            <div
              onKeyDown={() => {}}
              role="button"
              tabIndex="-1"
              onClick={() => store(value, workflowId, clientId)}
            >
              <div
                className={`school-item__button-radio-empty${
                  educationGoal.EducationType === value ? ' selected' : ''
                }`}
              />
              <button type="button" className="school-item__button">
                {label}
              </button>
            </div>
          </li>
        ))}
      </ul>
    </AdvForm>
    <Navigation
      nextIterators={nextIterators}
      dirtyGraphNodes={[]}
      validator={schoolSelected(educationGoal.EducationType)}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.EducationType`}
      workflowId={workflowId}
      backendKey={BACKEND_EDUCATION_GOAL_API}
      doNotSave={!isEditingGoal && educationGoal.EducationType === OTHER_TUITION}
      onPostProcess={data => onPostProcess(data, educationGoal)}
      validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'school_type_completed')}
    />
  </AdvWorkflowStep>
);

ChildrenSelectionView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  store: PropTypes.func.isRequired,
  educationTypeOptions: PropTypes.arrayOf({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  }).isRequired,
  selectedChildFirstName: PropTypes.string.isRequired,
  isEditingGoal: PropTypes.bool.isRequired,
  educationGoal: PropTypes.shape({
    EducationType: PropTypes.number,
  }).isRequired,
  onPostProcess: PropTypes.func.isRequired,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
};

export default ChildrenSelectionView;
